let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("exru3")).then(() => parcelRequire('5kUKd'));